import React from 'react';
import Button from '../components/Button';

const Events = () => {
    const offerings = [
        { id: 1, title: 'School / college events' },
        { id: 2, title: 'Corporate events' },
        { id: 3, title: 'Cinematic programs' }
    ];

    return (
        <div className="events-page">
            {/* Hero Section */}
            <section className="hero" style={{ minHeight: '60vh' }}>
                <div className="hero-content">
                    <h1 className="hero-title">Events & Programs</h1>
                    <p className="hero-subtitle">Bringing Traditional Arts to Every Stage</p>
                </div>
            </section>

            {/* Content Section */}
            <section className="section section-dark">
                <div style={{
                    maxWidth: '900px',
                    margin: '0 auto',
                    background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.98), rgba(5, 5, 5, 0.95))',
                    padding: '3rem',
                    borderRadius: 'var(--radius-lg)',
                    border: '1px solid rgba(0, 229, 255, 0.3)',
                    boxShadow: 'var(--shadow-xl)'
                }}>
                    <div style={{
                        display: 'inline-block',
                        padding: '0.5rem 1rem',
                        background: 'var(--color-gold)',
                        color: 'var(--color-black)',
                        fontWeight: 'bold',
                        borderRadius: 'var(--radius-sm)',
                        fontSize: '0.9rem',
                        marginBottom: '2rem',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    }}>
                        Other Events and Programs
                    </div>

                    <h2 style={{
                        fontFamily: 'var(--font-heading)',
                        fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                        marginBottom: '1.5rem',
                        color: 'var(--color-gold-light)'
                    }}>
                        Other Events and Programs
                    </h2>

                    <p style={{
                        fontSize: '1.2rem',
                        color: 'rgba(255, 255, 255, 0.8)',
                        marginBottom: '2.5rem'
                    }}>
                        Specialized training and performances. <span style={{ color: 'var(--color-gold-light)', fontWeight: '600' }}>(CONTACT FOR PRICE)</span>
                    </p>

                    <h3 style={{
                        fontSize: '1.4rem',
                        color: 'var(--color-gold)',
                        marginBottom: '2rem',
                        fontWeight: '700'
                    }}>
                        Our Offerings:
                    </h3>

                    <div style={{ marginBottom: '3rem' }}>
                        {offerings.map(item => (
                            <div key={item.id} style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '1.5rem 0',
                                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                                fontSize: '1.3rem'
                            }}>
                                <span style={{ marginRight: '1rem', color: '#FF7043' }}>⚡</span>
                                <span>{item.title}</span>
                            </div>
                        ))}
                    </div>

                    <Button to="/contact" style={{
                        padding: '1rem 2rem',
                        fontSize: '1.1rem',
                        borderRadius: 'var(--radius-sm)'
                    }}>
                        CONTACT FOR EVENTS
                    </Button>
                </div>
            </section>
        </div>
    );
};

export default Events;
